import { Grid } from '@mui/material';
import { DraftCardVideo } from '../draft-card-video/draft-card-video';
import { DraftCardImage } from '../draft-card-image/draft-card-image';
import { isVideo } from 'components/uploaded-images/helpers';
import { isPostDraftUpload } from '../../utils';
import { TActivityFeedDraftItemUploads } from 'redux-store/api/activity-feed';

interface IDraftCardMediaItem {
  item: TActivityFeedDraftItemUploads[number];
  onMediaViewerOpen: () => void;
}

export const DraftCardMediaItem = ({ item, onMediaViewerOpen }: IDraftCardMediaItem) => {
  return (
    <Grid onClick={onMediaViewerOpen}>
      {isVideo(item.mimeType) && isPostDraftUpload(item) ? (
        <DraftCardVideo
          src={item.options.previewUrl}
          alt={item.name}
          duration={item?.options?.duration}
        />
      ) : (
        <DraftCardImage src={item.url} alt={item.name} />
      )}
    </Grid>
  );
};
